import { render, staticRenderFns } from "./manpowerForm.vue?vue&type=template&id=22819ab4&scoped=true&"
import script from "./manpowerForm.vue?vue&type=script&lang=js&"
export * from "./manpowerForm.vue?vue&type=script&lang=js&"
import style0 from "./manpowerForm.vue?vue&type=style&index=0&id=22819ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22819ab4",
  null
  
)

export default component.exports